// Generated by genversion.
export const version = '3.2.8-SNAPSHOT';
//# sourceMappingURL=version.mjs.map